import WizardDocumentAPI from 'dashboard/api/wizard/document';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'WizardDocument',
  API: WizardDocumentAPI,
  actions: mutations => ({
    removeBulkRecords({ commit, getters }, ids) {
      const records = getters.getRecords.filter(
        record => !ids.includes(record.id)
      );
      commit(mutations.SET, records);
    },
  }),
});
